import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_treatment_line_RowClass } from '../../../dbschema';

export class DgMktTreatmentLineContainerModel extends BaseContainerModel {
  bl_dgmkt_treatment_ext: bl_dgmkt_treatment_line_RowClass =
    new bl_dgmkt_treatment_line_RowClass();
}
